import BaseService from '../BaseService';

class AcompanhamentoMedicoService extends BaseService {
    constructor() {
        super('/atendimentos/acompanhamento-medico/');
    }

    listar(atendimentoId, ordenarPor = 'data_proxima_consulta', ordem = 'asc') {
        return this.getAll({
            atendimento_id: atendimentoId,
            ordenar_por: ordenarPor,
            ordem,
        });
    }
}

export default new AcompanhamentoMedicoService();
